import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonapiService } from '../Module/Shared/Service/Commonapi.service';
import { Common } from '../Module/Shared/Utility/Common';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private api: CommonapiService) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let stateurl = state.url;
    let loggedin = true;//Common.GetStorageORCookie("LoggedInv2");
    if (stateurl.indexOf("/login") != -1) {
      if (this.api.isLoggedin()) {
        {
            this.router.navigateByUrl('/user/dashboard?status=resume');
        }
      }
    } else if (this.api.isLoggedin()) {
    } else {
      this.api.LocalStorageClear();
      this.router.navigateByUrl('/login');
    }
    return true;
  }
  


}
